import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ShirtUpdate from "./update/shirtUpdate.mjs";
import HoodieUpdate from "./update/hoodieUpdate.mjs";
import JacketUpdate from "./update/jacketUpdate.mjs";
import KurtaUpdate from "./update/kurtaUpdate.mjs";
import SareeUpdate from "./update/sareeUpdate.mjs";
import ShawlUpdate from "./update/shawlUpdate.mjs";
import TracksuitUpdate from "./update/tracksuitUpdate.mjs";
import LeggingsUpdate from "./update/leggingsUpdate.mjs";
import SkirtUpdate from "./update/skirtUpdate.mjs";
import JeansdUpdate from "./update/jeansUpdate.mjs";
import DressUpdate from "./update/dressUpdate.mjs";
import LehengaUpdate from "./update/lehengaUpdate.mjs";
import TopdUpdate from "./update/topUpdate.mjs";
import CoordUpdate from "./update/coordUpdate.mjs";
import EarRingUpdate from "./update/earRingsUpdate.mjs";
import BandUpdate from "./update/sacredBandUpdate.mjs";
import HandbagUpdate from "./update/handBagUpdate.mjs";
import HandPurseUpdate from "./update/handPurseUpdate.mjs";
import WalletUpdate from "./update/walletUpdate.mjs";
import BackpackUpdate from "./update/backpackUpdate.mjs";
import BeltUpdate from "./update/beltUpdate.mjs";
import UmbrellaUpdate from "./update/umbrellaUpdate.mjs";

export default function Update({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    const { prodType, prodId } = useParams();
    const [prod, setProdInfo] = useState(null);
    const navigate = useNavigate();
    let jToken = localStorage.getItem('token');

    useEffect(() => {
        setProdInfo(prev => {
            return { ...prev, 'prod': prodType };
        });
    }, [prodType]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/api/update/${prodType}/${prodId}`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: "include"
                })
                if (response.status === 200) {
                    const res = await response.json();
                    setProdInfo(prev => {
                        return { ...prev, ...res };
                    });
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            } catch (error) {
                navigate('/error');
                console.log(error.message);
            }
        }

        fetchData();
    }, [apiURL, navigate, loginStatus, prodId, prodType, jToken]);


    return (
        <>{prod &&
            (
                ['Shirt', 'T-shirt'].includes(prod['genre']) ?
                    (<ShirtUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                    prod['genre'] === 'Hoodie' ?
                        (<HoodieUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                        prod['genre'] === 'Jacket' ?
                            (<JacketUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                            ['Kurti', 'Kurta'].includes(prod['genre']) ?
                                (< KurtaUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                prod['genre'] === 'Saree' ?
                                    (< SareeUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                    prod['genre'] === 'Shawl' ?
                                        (< ShawlUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                        prod['genre'] === 'Tracksuit' ?
                                            (< TracksuitUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                            prod['genre'] === 'Leggings' ?
                                                (< LeggingsUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                prod['genre'] === 'Skirt' ?
                                                    (< SkirtUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                    prod['genre'] === 'Lehenga' ?
                                                        (< LehengaUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                        prod['genre'] === 'Dress' ?
                                                            (< DressUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                            prod['genre'] === 'Top' ?
                                                                (< TopdUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                prod['genre'] === 'Co ord set' ?
                                                                    (< CoordUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                    prod['genre'] === 'Jeans' ?
                                                                        (< JeansdUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                        prod['genre'] === 'Ear rings' ?
                                                                            (< EarRingUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                            prod['genre'] === 'Band' ?
                                                                                (< BandUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                prod['genre'] === 'Hand bag' ?
                                                                                    (< HandbagUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                    prod['genre'] === 'Hand purse' ?
                                                                                        (< HandPurseUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                        prod['genre'] === 'Wallet' ?
                                                                                            (< WalletUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                            prod['genre'] === 'Backpack' ?
                                                                                                (< BackpackUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                                prod['genre'] === 'Belt' ?
                                                                                                    (< BeltUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                                    prod['genre'] === 'Umbrella' ?
                                                                                                        (< UmbrellaUpdate id={prodId} prod={prod} setProd={setProdInfo} loginStatus={loginStatus} />) :
                                                                                                        (<></>)
            )
        }
        </>
    )
};